export const environment = {
    production: false,
    ambiente: 'DEV',

    api: 'http://localhost:60915/',
    webUrl: 'https://minhasnotificacoesdev.uninter.com/',

    apiAccount: 'https://accountapidev.uninter.com/',
    webAccount: 'https://accountdev.uninter.com/'
  };